export default __webpack_public_path__ + "static/media/rules.d4bde9b8.png";